<template>
  <div class="tipsText">
    {{dataInfo.tipsText}}
  </div>
</template>
<script>
export default {
  props: {
    dataInfo: {},
  },
};
</script>
<style lang="scss" scoped>
.tipsText {
  color: #a6a6a6;
  font-size: 14px;
  margin-top: 20px;
}
</style>
